import { connect } from 'react-redux';

import { userForgotPassword } from './Auth.saga';
import ForgotPassword from './ForgotPassword';

const mapDispatchToProps = {
  handleSubmit: userForgotPassword,
};

export default connect(null, mapDispatchToProps)(ForgotPassword);
